// @ts-nocheck


import CommonApi from './../commonApi';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

const convertDataToServer = (inspectionGibddCost) => ({
  ...inspectionGibddCost,
  cost: convertFromRubToKop(inspectionGibddCost.cost)
});

const convertDataFromServer = (inspectionGibddCost) => ({
  ...inspectionGibddCost,
  cost: convertFromKopToRub(inspectionGibddCost.cost)
});

const inspectionGibddCost = new CommonApi(
  'inspectionGibddCost',
  'Стоимость ТО ГИБДД',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...inspectionGibddCost
};
